import { Bestseller } from 'containers/configurators-listing';
import { NoPhoto } from 'containers/configurators-listing/components/configurators-list/components/no-photo';
import { Rating, Typography } from 'fronton-react';
import React from 'react';
import { getRatingText } from 'utils';
import { CardWrapper, categoryCard, ContentWrapper, imgStyles, StyledDiv } from './styled';
import { CardPrice } from '../card-price';

type BestsellersProps = {
	bestseller: Bestseller;
};

export const BestsellerCard = ({ bestseller }: BestsellersProps) => {
	const {
		name,
		imageUrl,
		pageUrl,
		lowestServicePrice,
		measurementUnitName,
		avgRating,
		totalReviews,
	} = bestseller;

	const reviewsUrl = `${pageUrl}/#reviews`;
	const ratingText =
		totalReviews === 0 ? 'Нет отзывов' : `${totalReviews} ${getRatingText(totalReviews)}`;

	const onClick = (e: React.MouseEvent<HTMLElement>) => {
		e.preventDefault();
		e.stopPropagation();

		window.location.assign(reviewsUrl);
	};

	return (
		<CardWrapper href={`${pageUrl}/`} className={categoryCard} data-qa="bestseller-card">
			{imageUrl ? (
				<img
					src={imageUrl}
					alt={name}
					className={imgStyles}
					data-qa="card-photo"
					data-analyticsName="productPhotoLink"
				/>
			) : (
				<NoPhoto />
			)}
			<ContentWrapper>
				<StyledDiv>
					<Typography
						variant="s"
						size="body_short"
						as="h3"
						data-qa="card-name"
						data-analyticsName="productNameLink"
					>
						{name}
					</Typography>
					<Rating size="s" value={avgRating} onClick={onClick}>
						{ratingText}
					</Rating>
				</StyledDiv>
				<CardPrice price={lowestServicePrice} unit={measurementUnitName} />
			</ContentWrapper>
		</CardWrapper>
	);
};
